import { useFeatureValue } from '@growthbook/growthbook-react';
import useHardwareFirstFreeTrial from './useHardwareFirstFreeTrial';

/**
 * Whether the hardware-first trial is on offer: its own flag and the legacy 'free-trial-enabled' kill switch.
 * Per-visitor eligibility is useFreeTrialEligibility with `includeHardwareFirst`.
 */
export default function useHardwareFirstTrialOffered(): boolean {
  const hardwareFirstTrial = useHardwareFirstFreeTrial();
  const freeTrialEnabled = useFeatureValue<boolean>('free-trial-enabled', false);
  return hardwareFirstTrial && freeTrialEnabled;
}
